import { render, staticRenderFns } from "./Alunos.vue?vue&type=template&id=5c885006&scoped=true"
import script from "./Alunos.vue?vue&type=script&lang=js"
export * from "./Alunos.vue?vue&type=script&lang=js"
import style0 from "./Alunos.vue?vue&type=style&index=0&id=5c885006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c885006",
  null
  
)

export default component.exports